export function formatTimestampToDate(timestamp) {
    if (!timestamp || isNaN(Number(timestamp))) {
        return '-'
    }

    try {
        return new Intl.DateTimeFormat('en-US', {
            month: 'long',
            day: '2-digit',
            year: 'numeric',
        }).format(new Date(Number(timestamp)))
    } catch {
        return '-'
    }
}

export const formatTimestampToShortDate = timestamp => {
    const options = { month: 'short', day: 'numeric', year: 'numeric' }
    return new Intl.DateTimeFormat('en-US', options).format(new Date(timestamp))
}

export const formatStringToDate = dateStr => {
    const date = new Date(dateStr)
    if (isNaN(date.getTime())) {
        return '-'
    }
    const options = { month: 'long', day: 'numeric', year: 'numeric' }
    return date.toLocaleDateString('en-US', options)
}

export const formatToISODate = date => {
    if (!date) return null

    if (typeof date === 'string' && /^\d+$/.test(date)) {
        return new Date(Number(date)).toISOString()
    }

    if (typeof date === 'number') {
        return new Date(date).toISOString()
    }

    if (typeof date === 'string' && !isNaN(Date.parse(date))) {
        return new Date(date).toISOString()
    }

    return null
}
